const RELOAD_FLAG = "wixar.chunk-reload";

export const installChunkReload = (
  reload: () => void = () => window.location.reload(),
  storage: Storage = window.sessionStorage,
): (() => void) => {
  const onPreloadError = (event: Event): void => {
    event.preventDefault();
    if (storage.getItem(RELOAD_FLAG) === "1") return;
    storage.setItem(RELOAD_FLAG, "1");
    reload();
  };
  const onLoad = (): void => {
    storage.removeItem(RELOAD_FLAG);
  };
  window.addEventListener("vite:preloadError", onPreloadError);
  window.addEventListener("load", onLoad);
  return () => {
    window.removeEventListener("vite:preloadError", onPreloadError);
    window.removeEventListener("load", onLoad);
  };
};
